import { render } from "./CardVehicle.vue?vue&type=template&id=f11428f2"
import script from "./CardVehicle.vue?vue&type=script&lang=js"
export * from "./CardVehicle.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Mori\\Desktop\\aptopler-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__